import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { grey } from '@mui/material/colors';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import orderBy from 'lodash/orderBy';
import React from 'react';
import { homeStyles } from '..';
import HotSpotsLogo from '../../../assets/hotspots-logo.png';
import { ContentCategoryName, ContentDocument } from '../../../types';
import { HotSpotsMap } from './hotspots-map';

export function Events(props: {
  content: ContentDocument[];
  loading: boolean;
  isMobile: boolean;
}) {
  // Props
  const { content, loading, isMobile } = props;
  // State
  const [openMap, setOpenMap] = React.useState(false);
  const dataFiltered = content.filter(
    (c) => c.Category === ContentCategoryName['Upcoming Events'],
  );
  const data = orderBy(dataFiltered, 'DdocIndex');

  // Create Sorted Item Element
  const displayEvents = data.map(
    ({ DdocId, FileName, ThumbnailName, ThumbnailContent, Title, URL }) => {
      if (FileName || URL) {
        return (
          <Box
            key={DdocId}
            sx={{
              ...homeStyles.box,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-around',
            }}
          >
            <Box flex={1}>
              <img
                src={ThumbnailName || ThumbnailContent || undefined}
                alt={Title || ''}
                style={{ height: isMobile ? 75 : 80, margin: 10 }}
              />
            </Box>

            <Box flex={1}>
              <Button
                fullWidth
                component="a"
                href={FileName || URL || undefined}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  ...homeStyles.button,
                  fontSize: 12,

                  px: { xs: 2, sm: 4 },
                  py: 1,
                  maxWidth: { xs: 115, sm: 150 },
                }}
              >
                {URL && URL.includes('/events/') ? 'Get Tickets' : 'More Info'}
              </Button>
            </Box>
          </Box>
        );
      } else {
        return (
          <Box key={DdocId}>
            <img
              src={ThumbnailName || ThumbnailContent || undefined}
              alt={Title || undefined}
            />
          </Box>
        );
      }
    },
  );

  const handleOpenMap = () => {
    setOpenMap(!openMap);
  };

  const mobileHotSpots = (
    <Box
      sx={{
        ...homeStyles.box,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
      }}
    >
      <Box flex={1}>
        <img
          src={HotSpotsLogo}
          alt="HotSpots Logo"
          style={{ height: isMobile ? 75 : 80, margin: 10 }}
        />
      </Box>

      <Box flex={1}>
        <Button
          fullWidth
          onClick={handleOpenMap}
          sx={{
            ...homeStyles.button,
            fontSize: 12,
            px: { xs: 2, sm: 4 },
            py: 1,
            maxWidth: { xs: 115, sm: 150 },
          }}
        >
          Open Map
        </Button>
      </Box>
    </Box>
  );

  return (
    <Paper
      sx={{
        ...homeStyles.section,
        p: 0,
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        px={{ xs: 0, sm: 2 }}
        pb={3}
        spacing={isMobile ? 0 : 3}
        alignItems="center"
        justifyContent="center"
      >
        <Stack width="100%" display={isMobile ? 'none' : 'flex'}>
          <Box
            width="100%"
            py={3}
            sx={{
              ...homeStyles.title,
            }}
          >
            HOTSPOTS NEAR ME
          </Box>

          <Box mx={1} sx={{ boxShadow: `0px 0px 5px 1px ${grey[900]}` }}>
            <HotSpotsMap
              height={350}
              isMobile={isMobile}
              open={openMap}
              onOpen={handleOpenMap}
            />
          </Box>
        </Stack>
        <Stack width="100%">
          <Box
            width="100%"
            py={3}
            sx={{
              ...homeStyles.title,
            }}
          >
            UPCOMING EVENTS
          </Box>
          {!loading && data.length ? (
            <Stack spacing={2} px={1} width="100%" alignItems="stretch">
              {isMobile && mobileHotSpots}

              {displayEvents}
            </Stack>
          ) : (
            <Stack spacing={2}>
              {Array.from({ length: 3 }).map((_, index) => {
                return (
                  <Box key={index}>
                    <Skeleton
                      variant="rectangular"
                      width="100%"
                      height={130}
                      style={{ boxShadow: '2px 2px 5px gray' }}
                    />
                  </Box>
                );
              })}
            </Stack>
          )}
        </Stack>
      </Stack>
    </Paper>
  );
}
